import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function ConfirmationDialog(props) {
 const [open, setOpen] = React.useState(false);

 function handleClickOpen() {
  setOpen(true);
 }

 return (
  <Dialog
   open={props.open}
   onClose={props.onCancel}
   aria-labelledby="alert-dialog-title"
   aria-describedby="alert-dialog-description"
  >
   <DialogTitle id="alert-dialog-title">
     Are you sure?
   </DialogTitle>
   <DialogContent>
    <DialogContentText id="alert-dialog-description">
     Let Google help apps determine location. This means sending anonymous
     location data to Google, even when no apps are running.
    </DialogContentText>
   </DialogContent>
   <DialogActions>
    <Button onClick={props.onCancel} color="secondary">
     Cancel
    </Button>
    <Button onClick={props.onConfirm} color="primary" autoFocus>
     Confirm
    </Button>
   </DialogActions>
  </Dialog>
 );
}
